import * as React from 'react';



export default class Search extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
      
        <g id="Empty-screens" stroke="" strokeWidth="1" fill="" fillRule="evenodd">
            <g id="No-Workkards---Search" transform="translate(-876.000000, -21.000000)">
                <g id="Group-3">
                    <g id="Group-6" transform="translate(463.000000, 13.000000)">
                        <g id="Group-26">
                            <g id="Group-62" transform="translate(378.000000, 8.000000)">
                                <g id="" transform="translate(35.000000, 0.000000)">
                                    <g id="Search-icon-active">
                                        <g id="search-copy" transform="translate(1.000000, 1.000000)">
                                            <path className="colorStroke" d="M11.1095765,5.83552941 C11.1095765,8.83070588 8.68098824,11.2592941 5.68581176,11.2592941 C2.68981176,11.2592941 9.75404706,10.7025882 9.72687059,5.83552941 C9.6964,0.362352941 2.68981176,0.41175683 5.68581176,0.41175683 C8.68098824,0.41175683 11.1095765,2.84035294 11.1095765,5.83552941" id="Fill-1" fill=""></path>
                                            <path d="M11.2592118,5.83552941 C11.2592118,8.83070588 8.83144706,11.2592941 5.83544706,11.2592941 C2.84027059,11.2592941 0.411682353,8.83070588 0.411682353,5.83552941 C0.411682353,2.84035294 2.84027059,0.411764706 5.83544706,0.411764706 C8.83144706,0.411764706 11.2592118,2.84035294 11.2592118,5.83552941 Z" id="Stroke-3" stroke=""></path>
                                            <line  x1="9.61857647" y1="9.72069412" x2="13.4010471" y2="13.6069294" id="Stroke-5" stroke="" strokeLinecap="round"></line>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
